
  import * as ipxRuntime$jGsaerLeyfAb0gtko0XU1NdxFtKpiM8HBezXrGz6JmY from '/builds/develop/ia-ns-frontend-web-ihreapothekende/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.11.1_magicast@0.5.3/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$jGsaerLeyfAb0gtko0XU1NdxFtKpiM8HBezXrGz6JmY, defaults: {} }
    }
  }
